import { forwardRef } from "react";
import { space, layout, border, typography } from "styled-system";
import styled, { keyframes } from "styled-components";
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const baseColor = p => p.theme.colors.gray[3];
const highlightColor = p => p.theme.colors.gray[1];
const skeletonKeyframes = keyframes(["0%{background-position:-200px 0;}100%{background-position:calc(200px + 100%) 0;}"]);
const Bar = styled.span.withConfig({
  displayName: "skeleton__Bar",
  componentId: "sc-1n8bm23-0"
})(["animation:", " ", "s ease-in-out infinite;background-color:", ";background-image:linear-gradient( 90deg,", ",", ",", " );background-size:200px 100%;background-repeat:no-repeat;display:inline-block;line-height:1;width:100%;", " ", " ", " ", ""], skeletonKeyframes, p => p.duration, baseColor, baseColor, highlightColor, baseColor, space, layout, border, typography);
export const Skeleton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    count = 1,
    duration = 1.2,
    circle = false,
    ...rest
  } = _ref;
  const elements = [];
  const hasSize = rest.size || rest.width || rest.height;
  const borderRadius = circle && hasSize ? "50%" : "base";
  for (let i = 0; i < count; i++) {
    elements.push( /*#__PURE__*/_createElement(Bar, {
      ...rest,
      key: i,
      duration: duration,
      borderRadius: borderRadius
    }, "\u200C"));
  }
  return /*#__PURE__*/_jsx("span", {
    ref: ref,
    children: elements
  });
});
export default Skeleton;